import React, { useState, useEffect } from "react";
import { useLockViewportScroll } from "../../hook/useLockViewportScroll";
import RegisterWrapper from "./Register.style";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import LogRocket from "logrocket";
import enhancer, {
  normalizeRegisterDobDisplayValue,
  resolveRegisterValidationMessage,
} from "./Register.validator";
import AuthenticationApiSerivce from "../../api/AuthServices";
import AuthActions from "../../redux/auth/actions";
import { message } from "antd";
import { Loader } from "../../icons";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { RegistrationLayout } from "../RegistrationLayout/RegistrationLayout";
import RegistrationDobField from "../RegistrationLayout/RegistrationDobField";
import { RegistrationSetupNavbar } from "../RegistrationLayout/RegistrationSetupNavbar";
import {
  IS_LOG_ROCKET_ON,
  REGISTRATION_SETUP_STEP_META,
  REGISTRATION_SETUP_TOTAL_STEPS,
} from "../../helper/constants";
import {
  getRegistrationData,
  isRegistrationComplete,
  clearRegistrationData,
} from "../RegistrationSetup/registrationSetupStorage";
import {
  applyCheckEmailResumePrefill,
  buildCheckEmailAndCodePayload,
  canContinueFromEmailCodeCheck,
  getCheckEmailDisplayMessage,
  isCheckEmailCannotResume,
  isCheckEmailCompletedAccountNoResume,
  isCheckEmailNotFound,
  isCheckEmailResumeEligible,
  isCheckEmailSuccess,
  mapCheckEmailResponseToRegistrationData,
  mergePrefilledCategoryOptions,
  shouldShowProviderUnavailableScreen,
} from "../RegistrationSetup/registrationEmailResume";
import {
  goToNoProviderAvailableScreen,
  redirectIfProviderUnavailableBeforeApi,
  shouldGoToNoProviderScreen,
} from "../RegistrationSetup/registrationRdAvailability";
import { RESTORE_ACCOUNT_PASSWORD_STATE_KEY } from "../RegistrationSetup/registrationNavigation";
import {
  isRegistrationLoadRetryExhaustedError,
  isRequestCancelledError,
} from "../../api/requestRetry";
import { resolveUserSubmitErrorMessage } from "../../api/submitRequestErrors";
import {
  trackProviderAvailabilityChecked,
  trackRegistrationError,
  trackRegistrationStepBack,
  trackRegistrationStepCompleted,
} from "../../helper/registrationAnalytics";

const ACCOUNT_STEP = REGISTRATION_SETUP_STEP_META.ACCOUNT;

const { login } = AuthActions;

const queryString = require("query-string");

const EMAIL_CHECK_DEBOUNCE_MS = 600;

const PasswordVisibilityIcon = ({ visible }) =>
  visible ? (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ) : (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
      <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );

const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const mapCategoryListItem = (item, translate) => {
  const id = item?.id ?? item?.category_id;
  if (id == null) {
    return null;
  }

  const titleKey = item?.title ?? item?.name;
  const descriptionKey =
    item?.description ?? item?.subtitle ?? item?.info ?? item?.tooltip;

  return {
    id,
    title: titleKey ? translate(titleKey) : "",
    description: descriptionKey ? translate(descriptionKey) : "",
  };
};

const extractCategoryList = (res) => {
  if (Array.isArray(res?.data)) {
    return res.data;
  }
  if (Array.isArray(res?.data?.category_list)) {
    return res.data.category_list;
  }
  if (Array.isArray(res?.data?.list)) {
    return res.data.list;
  }
  return [];
};

const Register = (props) => {
  const { t, i18n } = useTranslation();
  const { login: loginAction } = props;
  const [codeLoading, setCodeLoading] = useState(false);
  const [emailCheckBlocked, setEmailCheckBlocked] = useState(false);
  const [emailCheckMessage, setEmailCheckMessage] = useState("");
  const [emailCheckMessageType, setEmailCheckMessageType] = useState("info");
  const [emailCheckComplete, setEmailCheckComplete] = useState(true);
  const [registrationCodeDisabled, setRegistrationCodeDisabled] = useState(false);
  const [whyBoxOpen, setWhyBoxOpen] = useState(false);
  const [knowledgeOptions, setKnowledgeOptions] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const {
    setFieldValue,
    setFieldTouched,
    setSubmitting,
    setTouched,
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    isSubmitting,
    isValid,
    validateForm,
  } = props;

  useLockViewportScroll();

  useEffect(() => {
    const controller = new AbortController();
    let cancelled = false;

    setCategoriesLoading(true);
    AuthenticationApiSerivce.categoryList(i18n.language, {
      signal: controller.signal,
    })
      .then((res) => {
        if (cancelled) return;
        if (res?.status) {
          const mapped = extractCategoryList(res)
            .map((item) => mapCategoryListItem(item, t))
            .filter(Boolean);
          if (mapped.length > 0) {
            const savedSelectedCategories =
              getRegistrationData().selectedCategories ?? [];
            setKnowledgeOptions(
              mergePrefilledCategoryOptions(mapped, savedSelectedCategories)
            );
          }
        }
      })
      .catch((err) => {
        if (
          cancelled ||
          isRequestCancelledError(err) ||
          isRegistrationLoadRetryExhaustedError(err)
        ) {
          return;
        }
      })
      .finally(() => {
        if (!cancelled) {
          setCategoriesLoading(false);
        }
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [i18n.language, t]);

  useEffect(() => {
    let shouldValidate = false;

    const queryCode = props.location.search
      ? queryString.parse(props.location.search).code
      : null;
    const hasQueryRegistrationCode =
      typeof queryCode === "string" && queryCode.trim().length > 0;

    if (hasQueryRegistrationCode) {
      setFieldValue("registrationCode", queryCode.trim().toUpperCase());
      setRegistrationCodeDisabled(true);
      shouldValidate = true;
    }

    const saved = localStorage.getItem("data");
    const shouldRestoreAccountPassword = Boolean(
      props.location?.state?.[RESTORE_ACCOUNT_PASSWORD_STATE_KEY]
    );
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (isRegistrationComplete(parsed)) {
          clearRegistrationData();
        } else {
        if (parsed.firstName) {
          setFieldValue("firstName", parsed.firstName);
          shouldValidate = true;
        }
        if (parsed.lastName) {
          setFieldValue("lastName", parsed.lastName);
          shouldValidate = true;
        }
        if (parsed.email) {
          setFieldValue("email", parsed.email);
          shouldValidate = true;
        }
        if (parsed.preferredName) {
          setFieldValue("preferredName", parsed.preferredName);
        }
        // Prefer ?code= from the URL over a stale localStorage value
        if (parsed.registrationCode && !hasQueryRegistrationCode) {
          setFieldValue("registrationCode", parsed.registrationCode);
          shouldValidate = true;
        }
        if (parsed.dob) {
          setFieldValue("dob", normalizeRegisterDobDisplayValue(parsed.dob));
          shouldValidate = true;
        }
        if (parsed.zipCode) {
          setFieldValue("zipCode", parsed.zipCode);
          shouldValidate = true;
        }
        if (parsed.categoryId) {
          setFieldValue("categoryId", parsed.categoryId);
          shouldValidate = true;
        }
        if (
          parsed.acceptedTerms === true ||
          parsed.isCheckedAcknowledgements === true
        ) {
          setFieldValue("acceptedTerms", true);
          shouldValidate = true;
        }
        if (parsed.selectedCategories?.length) {
          setKnowledgeOptions((current) =>
            mergePrefilledCategoryOptions(current, parsed.selectedCategories)
          );
        }
        if (shouldRestoreAccountPassword) {
          if (parsed.password) {
            setFieldValue("password", parsed.password);
            shouldValidate = true;
          }
          if (parsed.confirmPassword) {
            setFieldValue("confirmPassword", parsed.confirmPassword);
            shouldValidate = true;
          } else if (parsed.password) {
            setFieldValue("confirmPassword", parsed.password);
            shouldValidate = true;
          }
        }
        }
      } catch {
        // ignore invalid saved data
      }
    }

    if (shouldValidate) {
      validateForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const email = values.email.trim();
    setEmailCheckBlocked(false);
    setEmailCheckMessage("");

    if (!email || !isValidEmail(email)) {
      setEmailCheckComplete(true);
      return undefined;
    }

    setEmailCheckComplete(false);
    let cancelled = false;

    const timer = setTimeout(() => {
      AuthenticationApiSerivce.checkEmail({ email })
        .then((res) => {
          if (cancelled) return;

          if (isCheckEmailNotFound(res)) {
            setEmailCheckBlocked(false);
            setEmailCheckMessage("");
            return;
          }

          if (isCheckEmailCompletedAccountNoResume(res)) {
            setEmailCheckBlocked(false);
            setEmailCheckMessage("");
            message.info(
              getCheckEmailDisplayMessage(
                res,
                t("NUTRITION_REGISTER_ERR_ACCOUNT_COMPLETED")
              )
            );
            return;
          }

          if (isCheckEmailCannotResume(res)) {
            setEmailCheckBlocked(false);
            setEmailCheckMessage("");
            message.info(
              getCheckEmailDisplayMessage(
                res,
                t("NUTRITION_REGISTER_ERR_EMAIL_EXISTS")
              )
            );
            return;
          }

          if (isCheckEmailResumeEligible(res)) {
            const registrationData = applyCheckEmailResumePrefill({
              res,
              email,
              setFieldValue,
              validateForm,
              onRegistrationCodeLocked: setRegistrationCodeDisabled,
            });
            if (registrationData.selectedCategories?.length) {
              setKnowledgeOptions((current) =>
                mergePrefilledCategoryOptions(
                  current,
                  registrationData.selectedCategories
                )
              );
            }
            setEmailCheckBlocked(false);
            setEmailCheckMessage("");
            return;
          }

          setEmailCheckBlocked(false);
          setEmailCheckMessage("");
        })
        .catch(() => {
          if (!cancelled) {
            setEmailCheckMessage(
              resolveUserSubmitErrorMessage(null, {
                fallback: t("NUTRITION_REGISTER_ERR_VERIFY_EMAIL"),
                translate: t,
              })
            );
            setEmailCheckMessageType("error");
          }
        })
        .finally(() => {
          if (!cancelled) {
            setEmailCheckComplete(true);
          }
        });
    }, EMAIL_CHECK_DEBOUNCE_MS);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
    // Only re-check when the email value changes; avoid clearing the message on unrelated re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.email]);

  const showError = (field) => {
    if ((errors[field] && touched[field]) || submitCount > 0) {
      const key = errors[field];
      return (
        <div className="text-danger">
          {resolveRegisterValidationMessage(key, t)}
        </div>
      );
    }
    return null;
  };

  const getCode = () => {
    setCodeLoading(true);
    AuthenticationApiSerivce.getRegistrationCode()
      .then((res) => {
        if (res.status) {
          setRegistrationCodeDisabled(true);
          setFieldValue("registrationCode", res.data.code);
        } else {
          message.error(res.message);
        }
        setCodeLoading(false);
      })
      .catch(() => {
        setCodeLoading(false);
        message.error(t("NUTRITION_COMMON_ERR_TRY_AGAIN"));
      });
  };

  const closeRegistrationCode = () => {
    setRegistrationCodeDisabled(false);
    setFieldValue("registrationCode", "");
  };

  const handleCategorySelect = (id) => {
    setFieldValue("categoryId", id, true);
    setFieldTouched("categoryId", true, false);
  };

  const handleRegistrationCodeChange = (e) => {
    const upper = e.target.value.toUpperCase();
    setFieldValue("registrationCode", upper, true);
  };

  const handleZipCodeChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 5);
    setFieldValue("zipCode", digits, true);
  };

  const openStaticPageInNewTab = (event, type) => {
    event.preventDefault();
    event.stopPropagation();
    window.open(`/static-page?type=${type}`, "_blank");
  };

  const canContinue =
    isValid && !isSubmitting && !emailCheckBlocked && emailCheckComplete;

  const touchAllFields = () => {
    setTouched({
      firstName: true,
      lastName: true,
      preferredName: true,
      email: true,
      registrationCode: true,
      dob: true,
      zipCode: true,
      password: true,
      confirmPassword: true,
      categoryId: true,
      acceptedTerms: true,
    });
  };

  const onContinue = async (e) => {
    e.preventDefault();
    if (emailCheckBlocked) {
      message.error(
        emailCheckMessage || t("NUTRITION_REGISTER_ERR_EMAIL_EXISTS")
      );
      return;
    }

    touchAllFields();
    const formErrors = await validateForm();
    if (Object.keys(formErrors).length > 0) {
      trackRegistrationError({
        stepName: "account",
        stepNumber: 1,
        errorType: "validation_failed",
      });
      return;
    }

    const emailCodeParams = buildCheckEmailAndCodePayload(values);

    // Persist form values so unavailable-state-lead can run if we redirect.
    localStorage.setItem(
      "data",
      JSON.stringify({
        ...getRegistrationData(),
        ...values,
        registrationCode: values.registrationCode.toUpperCase(),
      })
    );

    if (redirectIfProviderUnavailableBeforeApi(props.history, getRegistrationData())) {
      return;
    }

    setSubmitting(true);
    try {
      const emailCodeRes =
        await AuthenticationApiSerivce.checkEmailAndCode(emailCodeParams);

      const emailCodeData = emailCodeRes?.data ?? {};
      const resumeMappedData = mapCheckEmailResponseToRegistrationData(
        emailCodeRes,
        values.email
      );

      if (isCheckEmailSuccess(emailCodeRes)) {
        trackProviderAvailabilityChecked();
      }

      const baseSavedData = {
        ...getRegistrationData(),
        ...resumeMappedData,
        ...values,
        registrationCode: values.registrationCode.toUpperCase(),
        emailCodeCheck: emailCodeData,
        canResume: true,
        providerCode: !!emailCodeData?.is_provider_code,
        providerType: emailCodeData?.provider_type,
        categories: emailCodeData?.categories ?? [],
        ...(emailCodeData?.zipcode
          ? { zipCode: String(emailCodeData.zipcode).trim() }
          : {}),
        ...(emailCodeData?.state_id != null
          ? { stateId: emailCodeData.state_id }
          : {}),
        ...(emailCodeData?.state_name
          ? { stateName: emailCodeData.state_name }
          : {}),
        ...(emailCodeData?.state_code
          ? { stateCode: emailCodeData.state_code }
          : {}),
      };

      const applyEmailCodeLogin = () => {
        if (!emailCodeData?.access_token) {
          return;
        }

        loginAction({
          accessToken: emailCodeData.access_token,
          userId: emailCodeData?.user?.id,
          firstName: emailCodeData?.user?.first_name,
          lastName: emailCodeData?.user?.last_name,
          email: emailCodeData?.user?.email,
          isLogin: true,
          state: emailCodeData?.user?.state,
          insurance: emailCodeData?.user?.user_insurance?.insurance,
          isCardPresent: emailCodeData?.is_card_present || false,
        });
        if (IS_LOG_ROCKET_ON && emailCodeData?.id) {
          LogRocket.identify(emailCodeData.id, {
            name: `${emailCodeData?.user?.first_name} ${emailCodeData?.user?.last_name}`,
            email: emailCodeData?.email,
          });
        }
      };

      if (
        shouldGoToNoProviderScreen(emailCodeRes) ||
        shouldShowProviderUnavailableScreen(emailCodeRes)
      ) {
        applyEmailCodeLogin();
        localStorage.setItem("data", JSON.stringify(baseSavedData));
        trackRegistrationStepCompleted("account", 1);
        goToNoProviderAvailableScreen(props.history, emailCodeRes);
        return;
      }

      if (!canContinueFromEmailCodeCheck(emailCodeRes)) {
        message.info(
          getCheckEmailDisplayMessage(
            emailCodeRes,
            t("NUTRITION_REGISTER_ERR_CONTINUE")
          )
        );
        return;
      }

      applyEmailCodeLogin();

      localStorage.setItem("data", JSON.stringify(baseSavedData));
      trackRegistrationStepCompleted("account", 1);
      props.history.push("/register/account/payment");
    } catch (err) {
      trackRegistrationError({
        stepName: "account",
        stepNumber: 1,
        errorType: "api_failed",
      });
      message.error(
        resolveUserSubmitErrorMessage(err, {
          fallback: t("NUTRITION_COMMON_ERR_TRY_AGAIN"),
          translate: t,
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <RegisterWrapper>
      <RegistrationLayout
        containScroll
        header={
          <RegistrationSetupNavbar
            stepMeta={ACCOUNT_STEP}
            totalSteps={REGISTRATION_SETUP_TOTAL_STEPS}
            onBack={() => {
              trackRegistrationStepBack("account");
              props.history.push("/register");
            }}
          />
        }
      >
        <div className="scroll-body">
          <div className="content-card">
            <form className="content-card-scroll" onSubmit={onContinue} noValidate>
              <div className="section-eyebrow">{t("NUTRITION_REGISTER_LBL_EYEBROW")}</div>
              <h2 className="section-title">{t("NUTRITION_REGISTER_LBL_TITLE")}</h2>
              <p className="section-sub">
                {t("NUTRITION_REGISTER_DESC_SUBTITLE")}
              </p>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label" htmlFor="firstName">
                    {t("FIRST_NAME")}{" "}
                    <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    className="form-input"
                    placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_FIRST_NAME")}
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {showError("firstName")}
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="lastName">
                    {t("LAST_NAME")}{" "}
                    <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    className="form-input"
                    placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_LAST_NAME")}
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {showError("lastName")}
                </div>
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="preferredName">
                  {t("PREFERRED_NAME")}
                </label>
                <input
                  type="text"
                  id="preferredName"
                  name="preferredName"
                  className="form-input"
                  placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_PREFERRED_NAME")}
                  value={values.preferredName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <div className="form-hint">
                  {t("NUTRITION_REGISTER_HINT_PREFERRED_NAME")}
                </div>
                {showError("preferredName")}
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="email">
                  {t("NUTRITION_COMMON_LBL_EMAIL_ADDRESS")}{" "}
                  <span className="required-mark">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-input"
                  placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_EMAIL")}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {showError("email")}
                {emailCheckMessage && emailCheckMessageType === "error" && (
                  <div className="text-danger">{emailCheckMessage}</div>
                )}
              </div>

              <div className="form-group reg-code-row">
                <label className="form-label" htmlFor="registrationCode">
                  {t("REGISTRATION_CODE")}{" "}
                  <span className="required-mark">*</span>
                </label>
                <input
                  type="text"
                  id="registrationCode"
                  name="registrationCode"
                  className="form-input uppercase"
                  placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_REG_CODE")}
                  value={values.registrationCode}
                  onChange={handleRegistrationCodeChange}
                  onBlur={handleBlur}
                  disabled={registrationCodeDisabled}
                />
                {registrationCodeDisabled && (
                  <span
                    className="reg-code-close"
                    onClick={closeRegistrationCode}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") closeRegistrationCode();
                    }}
                  >
                    X
                  </span>
                )}
                <div className="form-hint">
                  {t("NUTRITION_REGISTER_HINT_REG_CODE + …_BTN_NO_CODE")}{" "}
                  {!registrationCodeDisabled && (
                    <>
                      {codeLoading ? (
                        <Loader height={20} width={20} />
                      ) : (
                        <button
                          type="button"
                          className="form-hint-link"
                          onClick={getCode}
                        >
                          {t("DONT_HAVE_CODE")}
                        </button>
                      )}
                    </>
                  )}
                </div>
                {showError("registrationCode")}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label" htmlFor="reg-dob">
                    {t("DATE_OF_BIRTH")}{" "}
                    <span className="required-mark">*</span>
                  </label>
                  <RegistrationDobField
                    id="reg-dob"
                    name="dob"
                    value={values.dob}
                    onChange={(formatted, { touched }) => {
                      if (touched) {
                        setFieldTouched("dob", true);
                      }
                      setFieldValue("dob", formatted, touched);
                    }}
                    onBlur={() => setFieldTouched("dob", true, true)}
                  />
                  {showError("dob")}
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="reg-zip">
                    {t("ZIP_CODE")}{" "}
                    <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-input"
                    id="reg-zip"
                    name="zipCode"
                    placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_ZIP")}
                    maxLength={5}
                    inputMode="numeric"
                    value={values.zipCode}
                    onChange={handleZipCodeChange}
                    onBlur={handleBlur}
                  />
                  {showError("zipCode")}
                </div>
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="reg-password">
                  {t("CREATE_PASSWORD")}{" "}
                  <span className="required-mark">*</span>
                </label>
                <div className="password-input-wrap">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-input"
                    id="reg-password"
                    name="password"
                    placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_PASSWORD")}
                    autoComplete="new-password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword((visible) => !visible)}
                    aria-label={
                      showPassword
                        ? t("NUTRITION_REGISTER_ARIA_HIDE_PASSWORD")
                        : t("NUTRITION_REGISTER_ARIA_SHOW_PASSWORD")
                    }
                    aria-pressed={showPassword}
                  >
                    <PasswordVisibilityIcon visible={showPassword} />
                  </button>
                </div>
                {showError("password")}
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="reg-confirm-password">
                  {t("CONFIRM_PASSWORD")}{" "}
                  <span className="required-mark">*</span>
                </label>
                <div className="password-input-wrap">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-input"
                    id="reg-confirm-password"
                    name="confirmPassword"
                    placeholder={t("NUTRITION_REGISTER_PLACEHOLDER_CONFIRM_PASSWORD")}
                    autoComplete="new-password"
                    value={values.confirmPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() =>
                      setShowConfirmPassword((visible) => !visible)
                    }
                    aria-label={
                      showConfirmPassword
                        ? t("NUTRITION_REGISTER_ARIA_HIDE_CONFIRM_PASSWORD")
                        : t("NUTRITION_REGISTER_ARIA_SHOW_CONFIRM_PASSWORD")
                    }
                    aria-pressed={showConfirmPassword}
                  >
                    <PasswordVisibilityIcon visible={showConfirmPassword} />
                  </button>
                </div>
                {showError("confirmPassword")}
              </div>

              <div className={clsx("why-box", whyBoxOpen && "open")}>
                <button
                  type="button"
                  className="why-toggle"
                  onClick={() => setWhyBoxOpen((open) => !open)}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                  {t("NUTRITION_REGISTER_LBL_WHY_NEED")}
                </button>
                <div className="why-body">
                  {t("NUTRITION_REGISTER_DESC_WHY_NEED")}
                </div>
              </div>

              <div className="divider" />

              <div className="field-group-label">
                {t("CATEGORY_IMP_LABEL")}{" "}
                <span className="required-mark">*</span>
              </div>
              <p className="field-group-intro">
                {t("NUTRITION_REGISTER_DESC_GOALS")}
              </p>

              <div className="knowledge-options">
                {categoriesLoading ? (
                  <div className="form-hint">
                    <Loader height={20} width={20} />
                  </div>
                ) : (
                  knowledgeOptions.map((option) => (
                    <button
                      key={option.id}
                      type="button"
                      className={clsx(
                        "know-opt",
                        values.categoryId === option.id && "selected"
                      )}
                      onClick={() => handleCategorySelect(option.id)}
                    >
                      <div className="know-opt-dot">
                        {values.categoryId === option.id && (
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 12 12"
                            fill="none"
                            stroke="#fff"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="2 6 5 9 10 3" />
                          </svg>
                        )}
                      </div>
                      <div>
                        <div className="know-opt-title">{option.title}</div>
                        <div className="know-opt-desc">{option.description}</div>
                      </div>
                    </button>
                  ))
                )}
              </div>
              {showError("categoryId")}

              <div className="terms-agreement">
                <label className="terms-agreement-label" htmlFor="accepted-terms">
                  <input
                    id="accepted-terms"
                    name="acceptedTerms"
                    type="checkbox"
                    className="terms-agreement-checkbox"
                    checked={values.acceptedTerms}
                    onChange={(event) =>
                      setFieldValue("acceptedTerms", event.target.checked, true)
                    }
                    onBlur={handleBlur}
                  />
                  <span className="terms-agreement-text">
                    {t("REGISTRATION_LABEL_SIGNING_AGREE")}{" "}
                    <button
                      type="button"
                      className="terms-link"
                      onClick={(event) => openStaticPageInNewTab(event, "terms")}
                    >
                      {t("TERMS_AND_CONDITION")}
                    </button>
                    ,{" "}
                    <button
                      type="button"
                      className="terms-link"
                      onClick={(event) => openStaticPageInNewTab(event, "privacy")}
                    >
                      {t("PRIVACY_POLICY")}
                    </button>
                    ,{" "}
                    <button
                      type="button"
                      className="terms-link"
                      onClick={(event) => openStaticPageInNewTab(event, "hippa")}
                    >
                      {t("HIPPA_POLICY")}
                    </button>{" "}
                    {t("AND")}{" "}
                    <button
                      type="button"
                      className="terms-link"
                      onClick={(event) => openStaticPageInNewTab(event, "payment")}
                    >
                      Husk {t("PAYMENT_POLICY")}
                    </button>
                    .
                  </span>
                </label>
              </div>
              {showError("acceptedTerms")}

              <button
                type="submit"
                className="continue-btn"
                disabled={!canContinue}
              >
                {`${t("MORE_CHANGE_LANGUAGE_BTN_CONTINUE")} →`}
              </button>
            </form>
          </div>
        </div>
      </RegistrationLayout>
    </RegisterWrapper>
  );
};

export default compose(
  withRouter,
  enhancer,
  connect(null, { login })
)(Register);
